// Auto-generated US States & Counties data
// 51 states/DC with major counties

export const US_STATES = {
  "AL": "Alabama",
  "AK": "Alaska",
  "AZ": "Arizona",
  "AR": "Arkansas",
  "CA": "California",
  "CO": "Colorado",
  "CT": "Connecticut",
  "DE": "Delaware",
  "DC": "District of Columbia",
  "FL": "Florida",
  "GA": "Georgia",
  "HI": "Hawaii",
  "ID": "Idaho",
  "IL": "Illinois",
  "IN": "Indiana",
  "IA": "Iowa",
  "KS": "Kansas",
  "KY": "Kentucky",
  "LA": "Louisiana",
  "ME": "Maine",
  "MD": "Maryland",
  "MA": "Massachusetts",
  "MI": "Michigan",
  "MN": "Minnesota",
  "MS": "Mississippi",
  "MO": "Missouri",
  "MT": "Montana",
  "NE": "Nebraska",
  "NV": "Nevada",
  "NH": "New Hampshire",
  "NJ": "New Jersey",
  "NM": "New Mexico",
  "NY": "New York",
  "NC": "North Carolina",
  "ND": "North Dakota",
  "OH": "Ohio",
  "OK": "Oklahoma",
  "OR": "Oregon",
  "PA": "Pennsylvania",
  "RI": "Rhode Island",
  "SC": "South Carolina",
  "SD": "South Dakota",
  "TN": "Tennessee",
  "TX": "Texas",
  "UT": "Utah",
  "VT": "Vermont",
  "VA": "Virginia",
  "WA": "Washington",
  "WV": "West Virginia",
  "WI": "Wisconsin",
  "WY": "Wyoming"
};

export const COUNTIES_BY_STATE = {
  "AL": [
    "Autauga",
    "Baldwin",
    "Barbour",
    "Bibb",
    "Blount",
    "Bullock",
    "Butler",
    "Calhoun",
    "Chambers",
    "Cherokee",
    "Chilton",
    "Choctaw",
    "Clarke",
    "Clay",
    "Cleburne",
    "Coffee",
    "Colbert",
    "Conecuh",
    "Coosa",
    "Covington",
    "Crenshaw",
    "Cullman",
    "Dale",
    "Dallas",
    "DeKalb",
    "Elmore",
    "Escambia",
    "Etowah",
    "Fayette",
    "Franklin",
    "Geneva",
    "Greene",
    "Hale",
    "Henry",
    "Houston",
    "Jackson",
    "Jefferson",
    "Lamar",
    "Lauderdale",
    "Lawrence",
    "Lee",
    "Limestone",
    "Lowndes",
    "Macon",
    "Madison",
    "Marengo",
    "Marion",
    "Marshall",
    "Mobile",
    "Monroe",
    "Montgomery",
    "Morgan",
    "Perry",
    "Pickens",
    "Pike",
    "Randolph",
    "Russell",
    "Shelby",
    "St. Clair",
    "Sumter",
    "Talladega",
    "Tallapoosa",
    "Tuscaloosa",
    "Walker",
    "Washington",
    "Wilcox",
    "Winston"
  ],
  "AK": [
    "Anchorage",
    "Fairbanks North Star",
    "Juneau",
    "Kenai Peninsula",
    "Matanuska-Susitna",
    "Bethel",
    "Kodiak Island",
    "Nome",
    "North Slope",
    "Northwest Arctic",
    "Sitka",
    "Valdez-Cordova",
    "Denali"
  ],
  "AZ": [
    "Apache",
    "Cochise",
    "Coconino",
    "Gila",
    "Graham",
    "Greenlee",
    "La Paz",
    "Maricopa",
    "Mohave",
    "Navajo",
    "Pima",
    "Pinal",
    "Santa Cruz",
    "Yavapai",
    "Yuma"
  ],
  "AR": [
    "Arkansas",
    "Ashley",
    "Baxter",
    "Benton",
    "Boone",
    "Bradley",
    "Calhoun",
    "Carroll",
    "Chicot",
    "Clark",
    "Clay",
    "Cleburne",
    "Cleveland",
    "Columbia",
    "Conway",
    "Craighead",
    "Crawford",
    "Crittenden",
    "Cross",
    "Dallas",
    "Desha",
    "Drew",
    "Faulkner",
    "Franklin",
    "Fulton",
    "Garland",
    "Grant",
    "Greene",
    "Hempstead",
    "Hot Spring",
    "Howard",
    "Independence",
    "Izard",
    "Jackson",
    "Jefferson",
    "Johnson",
    "Lafayette",
    "Lawrence",
    "Lee",
    "Lincoln",
    "Little River",
    "Logan",
    "Lonoke",
    "Madison",
    "Marion",
    "Miller",
    "Mississippi",
    "Monroe",
    "Montgomery",
    "Nevada",
    "Newton",
    "Ouachita",
    "Perry",
    "Phillips",
    "Pike",
    "Poinsett",
    "Polk",
    "Pope",
    "Prairie",
    "Pulaski",
    "Randolph",
    "Saline",
    "Scott",
    "Searcy",
    "Sebastian",
    "Sevier",
    "Sharp",
    "St. Francis",
    "Stone",
    "Union",
    "Van Buren",
    "Washington",
    "White",
    "Woodruff",
    "Yell"
  ],
  "CA": [
    "Alameda",
    "Alpine",
    "Amador",
    "Butte",
    "Calaveras",
    "Colusa",
    "Contra Costa",
    "Del Norte",
    "El Dorado",
    "Fresno",
    "Glenn",
    "Humboldt",
    "Imperial",
    "Inyo",
    "Kern",
    "Kings",
    "Lake",
    "Lassen",
    "Los Angeles",
    "Madera",
    "Marin",
    "Mariposa",
    "Mendocino",
    "Merced",
    "Modoc",
    "Mono",
    "Monterey",
    "Napa",
    "Nevada",
    "Orange",
    "Placer",
    "Plumas",
    "Riverside",
    "Sacramento",
    "San Benito",
    "San Bernardino",
    "San Diego",
    "San Francisco",
    "San Joaquin",
    "San Luis Obispo",
    "San Mateo",
    "Santa Barbara",
    "Santa Clara",
    "Santa Cruz",
    "Shasta",
    "Sierra",
    "Siskiyou",
    "Solano",
    "Sonoma",
    "Stanislaus",
    "Sutter",
    "Tehama",
    "Trinity",
    "Tulare",
    "Tuolumne",
    "Ventura",
    "Yolo",
    "Yuba"
  ],
  "CO": [
    "Adams",
    "Alamosa",
    "Arapahoe",
    "Archuleta",
    "Baca",
    "Bent",
    "Boulder",
    "Broomfield",
    "Chaffee",
    "Cheyenne",
    "Clear Creek",
    "Conejos",
    "Costilla",
    "Crowley",
    "Custer",
    "Delta",
    "Denver",
    "Dolores",
    "Douglas",
    "Eagle",
    "El Paso",
    "Elbert",
    "Fremont",
    "Garfield",
    "Gilpin",
    "Grand",
    "Gunnison",
    "Hinsdale",
    "Huerfano",
    "Jackson",
    "Jefferson",
    "Kiowa",
    "Kit Carson",
    "La Plata",
    "Lake",
    "Larimer",
    "Las Animas",
    "Lincoln",
    "Logan",
    "Mesa",
    "Mineral",
    "Moffat",
    "Montezuma",
    "Montrose",
    "Morgan",
    "Otero",
    "Ouray",
    "Park",
    "Phillips",
    "Pitkin",
    "Prowers",
    "Pueblo",
    "Rio Blanco",
    "Rio Grande",
    "Routt",
    "Saguache",
    "San Juan",
    "San Miguel",
    "Sedgwick",
    "Summit",
    "Teller",
    "Washington",
    "Weld",
    "Yuma"
  ],
  "CT": [
    "Fairfield",
    "Hartford",
    "Litchfield",
    "Middlesex",
    "New Haven",
    "New London",
    "Tolland",
    "Windham"
  ],
  "DE": [
    "Kent",
    "New Castle",
    "Sussex"
  ],
  "DC": [
    "District of Columbia"
  ],
  "FL": [
    "Alachua",
    "Baker",
    "Bay",
    "Bradford",
    "Brevard",
    "Broward",
    "Calhoun",
    "Charlotte",
    "Citrus",
    "Clay",
    "Collier",
    "Columbia",
    "DeSoto",
    "Dixie",
    "Duval",
    "Escambia",
    "Flagler",
    "Franklin",
    "Gadsden",
    "Gilchrist",
    "Glades",
    "Gulf",
    "Hamilton",
    "Hardee",
    "Hendry",
    "Hernando",
    "Highlands",
    "Hillsborough",
    "Holmes",
    "Indian River",
    "Jackson",
    "Jefferson",
    "Lafayette",
    "Lake",
    "Lee",
    "Leon",
    "Levy",
    "Liberty",
    "Madison",
    "Manatee",
    "Marion",
    "Martin",
    "Miami-Dade",
    "Monroe",
    "Nassau",
    "Okaloosa",
    "Okeechobee",
    "Orange",
    "Osceola",
    "Palm Beach",
    "Pasco",
    "Pinellas",
    "Polk",
    "Putnam",
    "Santa Rosa",
    "Sarasota",
    "Seminole",
    "St. Johns",
    "St. Lucie",
    "Sumter",
    "Suwannee",
    "Taylor",
    "Union",
    "Volusia",
    "Wakulla",
    "Walton",
    "Washington"
  ],
  "GA": [
    "Appling",
    "Atkinson",
    "Bacon",
    "Baker",
    "Baldwin",
    "Banks",
    "Barrow",
    "Bartow",
    "Ben Hill",
    "Berrien",
    "Bibb",
    "Bleckley",
    "Brantley",
    "Brooks",
    "Bryan",
    "Bulloch",
    "Burke",
    "Butts",
    "Calhoun",
    "Camden",
    "Candler",
    "Carroll",
    "Catoosa",
    "Charlton",
    "Chatham",
    "Cherokee",
    "Clarke",
    "Clay",
    "Clayton",
    "Clinch",
    "Cobb",
    "Coffee",
    "Colquitt",
    "Columbia",
    "Cook",
    "Coweta",
    "Crawford",
    "Crisp",
    "Dade",
    "Dawson",
    "Decatur",
    "DeKalb",
    "Dodge",
    "Dooly",
    "Dougherty",
    "Douglas",
    "Early",
    "Echols",
    "Effingham",
    "Elbert",
    "Emanuel",
    "Evans",
    "Fannin",
    "Fayette",
    "Floyd",
    "Forsyth",
    "Franklin",
    "Fulton",
    "Gilmer",
    "Glascock",
    "Glynn",
    "Gordon",
    "Grady",
    "Greene",
    "Gwinnett",
    "Habersham",
    "Hall",
    "Hancock",
    "Haralson",
    "Harris",
    "Hart",
    "Heard",
    "Henry",
    "Houston",
    "Irwin",
    "Jackson",
    "Jasper",
    "Jeff Davis",
    "Jefferson",
    "Jenkins",
    "Johnson",
    "Jones",
    "Lamar",
    "Lanier",
    "Laurens",
    "Lee",
    "Liberty",
    "Lincoln",
    "Long",
    "Lowndes",
    "Lumpkin",
    "Macon",
    "Madison",
    "Marion",
    "McDuffie",
    "McIntosh",
    "Meriwether",
    "Miller",
    "Mitchell",
    "Monroe",
    "Montgomery",
    "Morgan",
    "Murray",
    "Muscogee",
    "Newton",
    "Oconee",
    "Oglethorpe",
    "Paulding",
    "Peach",
    "Pickens",
    "Pierce",
    "Pike",
    "Polk",
    "Pulaski",
    "Putnam",
    "Quitman",
    "Rabun",
    "Randolph",
    "Richmond",
    "Rockdale",
    "Schley",
    "Screven",
    "Seminole",
    "Spalding",
    "Stephens",
    "Stewart",
    "Sumter",
    "Talbot",
    "Taliaferro",
    "Tattnall",
    "Taylor",
    "Telfair",
    "Terrell",
    "Thomas",
    "Tift",
    "Toombs",
    "Towns",
    "Treutlen",
    "Troup",
    "Turner",
    "Twiggs",
    "Union",
    "Upson",
    "Walker",
    "Walton",
    "Ware",
    "Warren",
    "Washington",
    "Wayne",
    "Webster",
    "Wheeler",
    "White",
    "Whitfield",
    "Wilcox",
    "Wilkes",
    "Wilkinson",
    "Worth"
  ],
  "HI": [
    "Hawaii",
    "Honolulu",
    "Kalawao",
    "Kauai",
    "Maui"
  ],
  "ID": [
    "Ada",
    "Adams",
    "Bannock",
    "Bear Lake",
    "Benewah",
    "Bingham",
    "Blaine",
    "Boise",
    "Bonner",
    "Bonneville",
    "Boundary",
    "Butte",
    "Camas",
    "Canyon",
    "Caribou",
    "Cassia",
    "Clark",
    "Clearwater",
    "Custer",
    "Elmore",
    "Franklin",
    "Fremont",
    "Gem",
    "Gooding",
    "Idaho",
    "Jefferson",
    "Jerome",
    "Kootenai",
    "Latah",
    "Lemhi",
    "Lewis",
    "Lincoln",
    "Madison",
    "Minidoka",
    "Nez Perce",
    "Oneida",
    "Owyhee",
    "Payette",
    "Power",
    "Shoshone",
    "Teton",
    "Twin Falls",
    "Valley",
    "Washington"
  ],
  "IL": [
    "Adams",
    "Alexander",
    "Bond",
    "Boone",
    "Brown",
    "Bureau",
    "Calhoun",
    "Carroll",
    "Cass",
    "Champaign",
    "Christian",
    "Clark",
    "Clay",
    "Clinton",
    "Coles",
    "Cook",
    "Crawford",
    "Cumberland",
    "DeKalb",
    "DeWitt",
    "Douglas",
    "DuPage",
    "Edgar",
    "Edwards",
    "Effingham",
    "Fayette",
    "Ford",
    "Franklin",
    "Fulton",
    "Gallatin",
    "Greene",
    "Grundy",
    "Hamilton",
    "Hancock",
    "Hardin",
    "Henderson",
    "Henry",
    "Iroquois",
    "Jackson",
    "Jasper",
    "Jefferson",
    "Jersey",
    "Jo Daviess",
    "Johnson",
    "Kane",
    "Kankakee",
    "Kendall",
    "Knox",
    "Lake",
    "LaSalle",
    "Lawrence",
    "Lee",
    "Livingston",
    "Logan",
    "Macon",
    "Macoupin",
    "Madison",
    "Marion",
    "Marshall",
    "Mason",
    "Massac",
    "McDonough",
    "McHenry",
    "McLean",
    "Menard",
    "Mercer",
    "Monroe",
    "Montgomery",
    "Morgan",
    "Moultrie",
    "Ogle",
    "Peoria",
    "Perry",
    "Piatt",
    "Pike",
    "Pope",
    "Pulaski",
    "Putnam",
    "Randolph",
    "Richland",
    "Rock Island",
    "Saline",
    "Sangamon",
    "Schuyler",
    "Scott",
    "Shelby",
    "St. Clair",
    "Stark",
    "Stephenson",
    "Tazewell",
    "Union",
    "Vermilion",
    "Wabash",
    "Warren",
    "Washington",
    "Wayne",
    "White",
    "Whiteside",
    "Will",
    "Williamson",
    "Winnebago",
    "Woodford"
  ],
  "IN": [
    "Adams",
    "Allen",
    "Bartholomew",
    "Benton",
    "Blackford",
    "Boone",
    "Brown",
    "Carroll",
    "Cass",
    "Clark",
    "Clay",
    "Clinton",
    "Crawford",
    "Daviess",
    "Dearborn",
    "Decatur",
    "DeKalb",
    "Delaware",
    "Dubois",
    "Elkhart",
    "Fayette",
    "Floyd",
    "Fountain",
    "Franklin",
    "Fulton",
    "Gibson",
    "Grant",
    "Greene",
    "Hamilton",
    "Hancock",
    "Harrison",
    "Hendricks",
    "Henry",
    "Howard",
    "Huntington",
    "Jackson",
    "Jasper",
    "Jay",
    "Jefferson",
    "Jennings",
    "Johnson",
    "Knox",
    "Kosciusko",
    "LaGrange",
    "Lake",
    "LaPorte",
    "Lawrence",
    "Madison",
    "Marion",
    "Marshall",
    "Martin",
    "Miami",
    "Monroe",
    "Montgomery",
    "Morgan",
    "Newton",
    "Noble",
    "Ohio",
    "Orange",
    "Owen",
    "Parke",
    "Perry",
    "Pike",
    "Porter",
    "Posey",
    "Pulaski",
    "Putnam",
    "Randolph",
    "Ripley",
    "Rush",
    "Scott",
    "Shelby",
    "Spencer",
    "St. Joseph",
    "Starke",
    "Steuben",
    "Sullivan",
    "Switzerland",
    "Tippecanoe",
    "Tipton",
    "Union",
    "Vanderburgh",
    "Vermillion",
    "Vigo",
    "Wabash",
    "Warren",
    "Warrick",
    "Washington",
    "Wayne",
    "Wells",
    "White",
    "Whitley"
  ],
  "KS": [
    "Allen",
    "Anderson",
    "Atchison",
    "Barber",
    "Barton",
    "Bourbon",
    "Brown",
    "Butler",
    "Chase",
    "Chautauqua",
    "Cherokee",
    "Cheyenne",
    "Clark",
    "Clay",
    "Cloud",
    "Coffey",
    "Comanche",
    "Cowley",
    "Crawford",
    "Decatur",
    "Dickinson",
    "Doniphan",
    "Douglas",
    "Edwards",
    "Elk",
    "Ellis",
    "Ellsworth",
    "Finney",
    "Ford",
    "Franklin",
    "Geary",
    "Gove",
    "Graham",
    "Grant",
    "Gray",
    "Greeley",
    "Greenwood",
    "Hamilton",
    "Harper",
    "Harvey",
    "Haskell",
    "Hodgeman",
    "Jackson",
    "Jefferson",
    "Jewell",
    "Johnson",
    "Kearny",
    "Kingman",
    "Kiowa",
    "Labette",
    "Lane",
    "Leavenworth",
    "Lincoln",
    "Linn",
    "Logan",
    "Lyon",
    "Marion",
    "Marshall",
    "McPherson",
    "Meade",
    "Miami",
    "Mitchell",
    "Montgomery",
    "Morris",
    "Morton",
    "Nemaha",
    "Neosho",
    "Ness",
    "Norton",
    "Osage",
    "Osborne",
    "Ottawa",
    "Pawnee",
    "Phillips",
    "Pottawatomie",
    "Pratt",
    "Rawlins",
    "Reno",
    "Republic",
    "Rice",
    "Riley",
    "Rooks",
    "Rush",
    "Russell",
    "Saline",
    "Scott",
    "Sedgwick",
    "Seward",
    "Shawnee",
    "Sheridan",
    "Sherman",
    "Smith",
    "Stafford",
    "Stanton",
    "Stevens",
    "Sumner",
    "Thomas",
    "Trego",
    "Wabaunsee",
    "Wallace",
    "Washington",
    "Wichita",
    "Wilson",
    "Woodson",
    "Wyandotte"
  ],
  "KY": [
    "Adair",
    "Allen",
    "Anderson",
    "Ballard",
    "Barren",
    "Bath",
    "Bell",
    "Boone",
    "Bourbon",
    "Boyd",
    "Boyle",
    "Bracken",
    "Breathitt",
    "Breckinridge",
    "Bullitt",
    "Butler",
    "Caldwell",
    "Calloway",
    "Campbell",
    "Carlisle",
    "Carroll",
    "Carter",
    "Casey",
    "Christian",
    "Clark",
    "Clay",
    "Clinton",
    "Crittenden",
    "Cumberland",
    "Daviess",
    "Edmonson",
    "Elliott",
    "Estill",
    "Fayette",
    "Fleming",
    "Floyd",
    "Franklin",
    "Fulton",
    "Gallatin",
    "Garrard",
    "Grant",
    "Graves",
    "Grayson",
    "Green",
    "Greenup",
    "Hancock",
    "Hardin",
    "Harlan",
    "Harrison",
    "Hart",
    "Henderson",
    "Henry",
    "Hickman",
    "Hopkins",
    "Jackson",
    "Jefferson",
    "Jessamine",
    "Johnson",
    "Kenton",
    "Knott",
    "Knox",
    "Larue",
    "Laurel",
    "Lawrence",
    "Lee",
    "Leslie",
    "Letcher",
    "Lewis",
    "Lincoln",
    "Livingston",
    "Logan",
    "Lyon",
    "Madison",
    "Magoffin",
    "Marion",
    "Marshall",
    "Martin",
    "Mason",
    "McCracken",
    "McCreary",
    "McLean",
    "Meade",
    "Menifee",
    "Mercer",
    "Metcalfe",
    "Monroe",
    "Montgomery",
    "Morgan",
    "Muhlenberg",
    "Nelson",
    "Nicholas",
    "Ohio",
    "Oldham",
    "Owen",
    "Owsley",
    "Pendleton",
    "Perry",
    "Pike",
    "Powell",
    "Pulaski",
    "Robertson",
    "Rockcastle",
    "Rowan",
    "Russell",
    "Scott",
    "Shelby",
    "Simpson",
    "Spencer",
    "Taylor",
    "Todd",
    "Trigg",
    "Trimble",
    "Union",
    "Warren",
    "Washington",
    "Wayne",
    "Webster",
    "Whitley",
    "Wolfe",
    "Woodford"
  ],
  "LA": [
    "Acadia",
    "Allen",
    "Ascension",
    "Assumption",
    "Avoyelles",
    "Beauregard",
    "Bienville",
    "Bossier",
    "Caddo",
    "Calcasieu",
    "Caldwell",
    "Cameron",
    "Catahoula",
    "Claiborne",
    "Concordia",
    "De Soto",
    "East Baton Rouge",
    "East Carroll",
    "East Feliciana",
    "Evangeline",
    "Franklin",
    "Grant",
    "Iberia",
    "Iberville",
    "Jackson",
    "Jefferson",
    "Jefferson Davis",
    "La Salle",
    "Lafayette",
    "Lafourche",
    "Lincoln",
    "Livingston",
    "Madison",
    "Morehouse",
    "Natchitoches",
    "Orleans",
    "Ouachita",
    "Plaquemines",
    "Pointe Coupee",
    "Rapides",
    "Red River",
    "Richland",
    "Sabine",
    "St. Bernard",
    "St. Charles",
    "St. Helena",
    "St. James",
    "St. John the Baptist",
    "St. Landry",
    "St. Martin",
    "St. Mary",
    "St. Tammany",
    "Tangipahoa",
    "Tensas",
    "Terrebonne",
    "Union",
    "Vermilion",
    "Vernon",
    "Washington",
    "Webster",
    "West Baton Rouge",
    "West Carroll",
    "West Feliciana",
    "Winn"
  ],
  "ME": [
    "Androscoggin",
    "Aroostook",
    "Cumberland",
    "Franklin",
    "Hancock",
    "Kennebec",
    "Knox",
    "Lincoln",
    "Oxford",
    "Penobscot",
    "Piscataquis",
    "Sagadahoc",
    "Somerset",
    "Waldo",
    "Washington",
    "York"
  ],
  "MD": [
    "Allegany",
    "Anne Arundel",
    "Baltimore",
    "Baltimore City",
    "Calvert",
    "Caroline",
    "Carroll",
    "Cecil",
    "Charles",
    "Dorchester",
    "Frederick",
    "Garrett",
    "Harford",
    "Howard",
    "Kent",
    "Montgomery",
    "Prince George's",
    "Queen Anne's",
    "Somerset",
    "St. Mary's",
    "Talbot",
    "Washington",
    "Wicomico",
    "Worcester"
  ],
  "MA": [
    "Barnstable",
    "Berkshire",
    "Bristol",
    "Dukes",
    "Essex",
    "Franklin",
    "Hampden",
    "Hampshire",
    "Middlesex",
    "Nantucket",
    "Norfolk",
    "Plymouth",
    "Suffolk",
    "Worcester"
  ],
  "MI": [
    "Alcona",
    "Alger",
    "Allegan",
    "Alpena",
    "Antrim",
    "Arenac",
    "Baraga",
    "Barry",
    "Bay",
    "Benzie",
    "Berrien",
    "Branch",
    "Calhoun",
    "Cass",
    "Charlevoix",
    "Cheboygan",
    "Chippewa",
    "Clare",
    "Clinton",
    "Crawford",
    "Delta",
    "Dickinson",
    "Eaton",
    "Emmet",
    "Genesee",
    "Gladwin",
    "Gogebic",
    "Grand Traverse",
    "Gratiot",
    "Hillsdale",
    "Houghton",
    "Huron",
    "Ingham",
    "Ionia",
    "Iosco",
    "Iron",
    "Isabella",
    "Jackson",
    "Kalamazoo",
    "Kalkaska",
    "Kent",
    "Keweenaw",
    "Lake",
    "Lapeer",
    "Leelanau",
    "Lenawee",
    "Livingston",
    "Luce",
    "Mackinac",
    "Macomb",
    "Manistee",
    "Marquette",
    "Mason",
    "Mecosta",
    "Menominee",
    "Midland",
    "Missaukee",
    "Monroe",
    "Montcalm",
    "Montmorency",
    "Muskegon",
    "Newaygo",
    "Oakland",
    "Oceana",
    "Ogemaw",
    "Ontonagon",
    "Osceola",
    "Oscoda",
    "Otsego",
    "Ottawa",
    "Presque Isle",
    "Roscommon",
    "Saginaw",
    "Sanilac",
    "Schoolcraft",
    "Shiawassee",
    "St. Clair",
    "St. Joseph",
    "Tuscola",
    "Van Buren",
    "Washtenaw",
    "Wayne",
    "Wexford"
  ],
  "MN": [
    "Anoka",
    "Becker",
    "Beltrami",
    "Benton",
    "Blue Earth",
    "Brown",
    "Carlton",
    "Carver",
    "Cass",
    "Clay",
    "Crow Wing",
    "Dakota",
    "Dodge",
    "Douglas",
    "Freeborn",
    "Goodhue",
    "Hennepin",
    "Houston",
    "Isanti",
    "Itasca",
    "Kandiyohi",
    "Lake",
    "Le Sueur",
    "Lyon",
    "McLeod",
    "Morrison",
    "Mower",
    "Nicollet",
    "Olmsted",
    "Otter Tail",
    "Pine",
    "Polk",
    "Ramsey",
    "Rice",
    "Scott",
    "Sherburne",
    "St. Louis",
    "Stearns",
    "Steele",
    "Washington",
    "Winona",
    "Wright"
  ],
  "MS": [
    "Adams",
    "Bolivar",
    "DeSoto",
    "Forrest",
    "Harrison",
    "Hinds",
    "Jackson",
    "Jones",
    "Lamar",
    "Lauderdale",
    "Lee",
    "Lowndes",
    "Madison",
    "Pearl River",
    "Rankin",
    "Warren"
  ],
  "MO": [
    "Boone",
    "Buchanan",
    "Cape Girardeau",
    "Cass",
    "Christian",
    "Clay",
    "Cole",
    "Franklin",
    "Greene",
    "Jackson",
    "Jasper",
    "Jefferson",
    "Johnson",
    "Platte",
    "St. Charles",
    "St. Louis",
    "St. Louis City"
  ],
  "MT": [
    "Cascade",
    "Flathead",
    "Gallatin",
    "Lewis and Clark",
    "Missoula",
    "Yellowstone"
  ],
  "NE": [
    "Buffalo",
    "Dakota",
    "Douglas",
    "Hall",
    "Lancaster",
    "Lincoln",
    "Sarpy"
  ],
  "NV": [
    "Carson City",
    "Churchill",
    "Clark",
    "Douglas",
    "Elko",
    "Lyon",
    "Nye",
    "Washoe",
    "White Pine"
  ],
  "NH": [
    "Belknap",
    "Carroll",
    "Cheshire",
    "Coos",
    "Grafton",
    "Hillsborough",
    "Merrimack",
    "Rockingham",
    "Strafford",
    "Sullivan"
  ],
  "NJ": [
    "Atlantic",
    "Bergen",
    "Burlington",
    "Camden",
    "Cape May",
    "Cumberland",
    "Essex",
    "Gloucester",
    "Hudson",
    "Hunterdon",
    "Mercer",
    "Middlesex",
    "Monmouth",
    "Morris",
    "Ocean",
    "Passaic",
    "Salem",
    "Somerset",
    "Sussex",
    "Union",
    "Warren"
  ],
  "NM": [
    "Bernalillo",
    "Chaves",
    "Dona Ana",
    "Eddy",
    "Lea",
    "Otero",
    "San Juan",
    "Sandoval",
    "Santa Fe",
    "Valencia"
  ],
  "NY": [
    "Albany",
    "Bronx",
    "Broome",
    "Dutchess",
    "Erie",
    "Essex",
    "Kings",
    "Monroe",
    "Nassau",
    "New York",
    "Niagara",
    "Oneida",
    "Onondaga",
    "Ontario",
    "Orange",
    "Oswego",
    "Queens",
    "Rensselaer",
    "Richmond",
    "Rockland",
    "Saratoga",
    "Schenectady",
    "St. Lawrence",
    "Steuben",
    "Suffolk",
    "Sullivan",
    "Tompkins",
    "Ulster",
    "Westchester"
  ],
  "NC": [
    "Alamance",
    "Buncombe",
    "Burke",
    "Cabarrus",
    "Catawba",
    "Cumberland",
    "Davidson",
    "Durham",
    "Forsyth",
    "Gaston",
    "Guilford",
    "Harnett",
    "Henderson",
    "Iredell",
    "Johnston",
    "Mecklenburg",
    "Moore",
    "Nash",
    "New Hanover",
    "Onslow",
    "Orange",
    "Pitt",
    "Randolph",
    "Robeson",
    "Rowan",
    "Union",
    "Wake",
    "Wayne",
    "Wilson"
  ],
  "ND": [
    "Burleigh",
    "Cass",
    "Grand Forks",
    "Ward",
    "Williams"
  ],
  "OH": [
    "Allen",
    "Butler",
    "Clark",
    "Clermont",
    "Columbiana",
    "Cuyahoga",
    "Delaware",
    "Erie",
    "Fairfield",
    "Franklin",
    "Greene",
    "Hamilton",
    "Lake",
    "Licking",
    "Lorain",
    "Lucas",
    "Mahoning",
    "Medina",
    "Miami",
    "Montgomery",
    "Portage",
    "Richland",
    "Stark",
    "Summit",
    "Trumbull",
    "Tuscarawas",
    "Warren",
    "Wayne",
    "Wood"
  ],
  "OK": [
    "Canadian",
    "Cleveland",
    "Comanche",
    "Creek",
    "Garfield",
    "Kay",
    "Muskogee",
    "Oklahoma",
    "Osage",
    "Payne",
    "Pottawatomie",
    "Rogers",
    "Tulsa",
    "Wagoner",
    "Washington"
  ],
  "OR": [
    "Benton",
    "Clackamas",
    "Deschutes",
    "Douglas",
    "Jackson",
    "Josephine",
    "Klamath",
    "Lane",
    "Linn",
    "Marion",
    "Multnomah",
    "Polk",
    "Umatilla",
    "Washington",
    "Yamhill"
  ],
  "PA": [
    "Adams",
    "Allegheny",
    "Berks",
    "Blair",
    "Bucks",
    "Butler",
    "Cambria",
    "Centre",
    "Chester",
    "Cumberland",
    "Dauphin",
    "Delaware",
    "Erie",
    "Fayette",
    "Franklin",
    "Lackawanna",
    "Lancaster",
    "Lawrence",
    "Lebanon",
    "Lehigh",
    "Luzerne",
    "Lycoming",
    "Monroe",
    "Montgomery",
    "Northampton",
    "Philadelphia",
    "Schuylkill",
    "Washington",
    "Westmoreland",
    "York"
  ],
  "RI": [
    "Bristol",
    "Kent",
    "Newport",
    "Providence",
    "Washington"
  ],
  "SC": [
    "Aiken",
    "Anderson",
    "Beaufort",
    "Berkeley",
    "Charleston",
    "Dorchester",
    "Florence",
    "Georgetown",
    "Greenville",
    "Greenwood",
    "Horry",
    "Kershaw",
    "Lancaster",
    "Laurens",
    "Lexington",
    "Oconee",
    "Orangeburg",
    "Pickens",
    "Richland",
    "Spartanburg",
    "Sumter",
    "York"
  ],
  "SD": [
    "Brookings",
    "Brown",
    "Codington",
    "Lincoln",
    "Meade",
    "Minnehaha",
    "Pennington"
  ],
  "TN": [
    "Anderson",
    "Blount",
    "Bradley",
    "Davidson",
    "Hamilton",
    "Knox",
    "Madison",
    "Maury",
    "Montgomery",
    "Rutherford",
    "Sevier",
    "Shelby",
    "Sullivan",
    "Sumner",
    "Washington",
    "Williamson",
    "Wilson"
  ],
  "TX": [
    "Bexar",
    "Brazoria",
    "Brazos",
    "Cameron",
    "Collin",
    "Dallas",
    "Denton",
    "Ector",
    "El Paso",
    "Fort Bend",
    "Galveston",
    "Harris",
    "Hays",
    "Hidalgo",
    "Jefferson",
    "Johnson",
    "Kaufman",
    "Lubbock",
    "McLennan",
    "Midland",
    "Montgomery",
    "Nueces",
    "Parker",
    "Potter",
    "Randall",
    "Smith",
    "Tarrant",
    "Taylor",
    "Tom Green",
    "Travis",
    "Webb",
    "Wichita",
    "Williamson"
  ],
  "UT": [
    "Box Elder",
    "Cache",
    "Davis",
    "Iron",
    "Salt Lake",
    "Summit",
    "Tooele",
    "Utah",
    "Washington",
    "Weber"
  ],
  "VT": [
    "Addison",
    "Bennington",
    "Caledonia",
    "Chittenden",
    "Essex",
    "Franklin",
    "Grand Isle",
    "Lamoille",
    "Orange",
    "Orleans",
    "Rutland",
    "Washington",
    "Windham",
    "Windsor"
  ],
  "VA": [
    "Albemarle",
    "Arlington",
    "Augusta",
    "Bedford",
    "Campbell",
    "Chesterfield",
    "Fairfax",
    "Fauquier",
    "Frederick",
    "Hanover",
    "Henrico",
    "James City",
    "Loudoun",
    "Montgomery",
    "Pittsylvania",
    "Prince William",
    "Roanoke",
    "Rockingham",
    "Spotsylvania",
    "Stafford",
    "Washington",
    "York"
  ],
  "WA": [
    "Benton",
    "Clark",
    "Cowlitz",
    "Franklin",
    "Grant",
    "Island",
    "King",
    "Kitsap",
    "Lewis",
    "Pierce",
    "Skagit",
    "Snohomish",
    "Spokane",
    "Thurston",
    "Whatcom",
    "Yakima"
  ],
  "WV": [
    "Berkeley",
    "Cabell",
    "Kanawha",
    "Marion",
    "Mercer",
    "Monongalia",
    "Putnam",
    "Raleigh",
    "Wood"
  ],
  "WI": [
    "Brown",
    "Dane",
    "Dodge",
    "Eau Claire",
    "Fond du Lac",
    "Kenosha",
    "La Crosse",
    "Marathon",
    "Milwaukee",
    "Outagamie",
    "Racine",
    "Rock",
    "Sheboygan",
    "Walworth",
    "Washington",
    "Waukesha",
    "Winnebago"
  ],
  "WY": [
    "Albany",
    "Campbell",
    "Fremont",
    "Laramie",
    "Natrona",
    "Sweetwater"
  ]
};

export const US_STATE_OPTIONS = Object.entries(US_STATES)
  .map(([abbr, name]) => ({ value: abbr, label: name }))
  .sort((a, b) => a.label.localeCompare(b.label));

export function getCountiesForState(stateAbbr) {
  if (!stateAbbr) return [];
  return (COUNTIES_BY_STATE[stateAbbr] || []).map(c => c + ' County');
}

export function getAllCounties() {
  const all = [];
  for (const [st, counties] of Object.entries(COUNTIES_BY_STATE)) {
    for (const c of counties) {
      all.push({ county: c + ' County', state: st });
    }
  }
  return all.sort((a, b) => a.county.localeCompare(b.county));
}
